import { render } from "./RqNotesCard.vue?vue&type=template&id=aa23cfd8"
import script from "./RqNotesCard.vue?vue&type=script&lang=js"
export * from "./RqNotesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__